import { render, staticRenderFns } from "./classProductService1.vue?vue&type=template&id=0755dcf2&scoped=true&"
import script from "./classProductService1.vue?vue&type=script&lang=ts&"
export * from "./classProductService1.vue?vue&type=script&lang=ts&"
import style0 from "./classProductService1.vue?vue&type=style&index=0&id=0755dcf2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0755dcf2",
  null
  
)

export default component.exports